import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";
import { Box, Typography } from "@mui/material";
import { Tooltip } from "recharts";
import { colors } from "../components/colorList";
import { persianDigitWithSeprator } from "../components/PersianDigit";

function ChartRenderer({ dataLineChart, salseExperts }) {
  const toPersianDigits = (str) => {
    if (!str) return "";
    return str.toString().replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);
  };
  const defaultColor = "rgba(53, 146, 251, 1)";

  return (
    <Box sx={{ width: "100%", height: "18rem" }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={dataLineChart}
          margin={{ top: 5, right: 10, left: 0, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="name"
            fontSize={"10px"}
            angle={10}
            tickMargin={10}
            tickFormatter={(value) => toPersianDigits(value)}
          />
          <YAxis
            tickMargin={40}
            fontSize={"13px"}
            tickFormatter={(value) => toPersianDigits(value)}
          />
          <Tooltip
            content={({ active, payload, label }) => {
              if (active && payload && payload.length) {
                const data = payload[0].payload;
                return (
                  <div
                    style={{
                      background: "#fff",
                      padding: "10px",
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                    }}
                  >
                    {salseExperts?.map((item, i) => {
                      const strokeColor = colors[i] ?? defaultColor;
                      const key = i === 0 ? "value" : `value${i}`;
                      return (
                        <Typography fontSize={14} color={strokeColor}>
                          {item} :
                          {i === 0
                            ? persianDigitWithSeprator(data.value)
                            : persianDigitWithSeprator(data[key])}
                        </Typography>
                      );
                    })}
                  </div>
                );
              }
              return null;
            }}
          />
          {salseExperts?.map((item, i) => {
            const strokeColor = colors[i] ?? defaultColor;
            return (
              <Line
                type="monotone"
                name={item}
                dataKey={i === 0 ? "value" : `value${i}`}
                stroke={strokeColor}
                activeDot={{ r: 8 }}
              />
            );
          })}
        </LineChart>
      </ResponsiveContainer>
    </Box>
  );
}

export default ChartRenderer;
